import React from 'react'
import { Card } from '../../../Components/Common/Card'
import { Flex } from '../../../Components/Common/Flex'
import { Text } from '../../../Components/Common/Text'
import { Button } from '../../../Components/Common/Button'

export const DraggableCard = ({ onAdd = () => {}, children, label = '' }) => (
  <Card
    style={{ width: '100%', marginBottom: 20 }}
    collapsable
    customHeader={(
      <Flex fw jb row>
        <Text value={label} upCase title bold size={18} />
        <Button label='Aggiungi' onClick={onAdd} style={{ marginRight: 10 }} />
      </Flex>)}
  >
    <Flex fw as>
      {children}
    </Flex>
  </Card>
)

export const DraggableCardElement = ({ id, hide, hideElement, deleteElement, copyElement, children }) => (
  <Flex js fw row style={{ marginTop: 10, border: '1px solid white', padding: 10, position: 'relative' }}>
    <div style={{ color: 'white', fontSize: 10, position: 'absolute', top: 0, left: 0, width: 150 }}>
      {id}
    </div>
    <Flex fw as>
      {children}
    </Flex>
    <Button
      onClick={deleteElement} icon='fa-duotone fa-trash' round
      style={{ marginLeft: 10, position: 'absolute', right: 0, top: -10 }}
    />
    <Button
      onClick={copyElement} icon='fa-duotone fa-copy' round
      style={{ marginLeft: 10, position: 'absolute', right: 30, top: -10 }}
    />
    <Button
      icon={'fa-duotone ' + (!hide ? 'fa-eye' : 'fa-eye-slash')} round
      style={{ marginLeft: 10, position: 'absolute', right: 60, top: -10 }}
      allowMultipleClick
      onClick={hideElement}
    />
  </Flex>
)
